import { Component, FormEvent, ReactNode } from 'react';
import { Button, Form } from 'react-bootstrap';
import { APIRequestGet, APIRequestPost } from '../utils/APIRequests';
import {
    FirmwareDataList,
    FirmwareListSchema,
    FirmwaresDeleteRequestData,
    FirmwaresFirmwareLoadRequestData,
    FirmwaresSetReleaseRequestData
} from '../api/Firmwares';
import FirmwareInfoTable from './FirmwareInfoTable';

interface FirmwareState {
    firmwareText: string;
    loading: boolean;
    firmwareList: FirmwareDataList;
}

export class Firmware extends Component {
    static displayName = Firmware.name;

    override state: FirmwareState;

    constructor(props: Record<string, unknown>) {
        super(props);

        this.state = {
            firmwareText: "",
            loading: true,
            firmwareList: []
        };
    }

    override componentDidMount(): void {
        this.updateFirmwares();
    }

    toDownloadMode(): void {
        APIRequestGet(`serialTest/toDownloadMode`, {
            logSuccess: true
        });
    }

    onSubmitFile = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        let formFile: File | undefined = undefined;
        let fileName = "";
        if (event.currentTarget[0]) {
            const fileInput = event.currentTarget[0] as HTMLInputElement;
            if (fileInput.files && fileInput.files[0]) {
                formFile = fileInput.files[0];
                fileName = fileInput.files[0].name;
            }
            else {
                console.warn("Firmware: no file attached");
            }
        }

        let version = "0";
        if (event.currentTarget[1]) {
            const versionInput = event.currentTarget[1] as HTMLInputElement;
            version = versionInput.value;
        }

        let deviceVersion = "";
        if (event.currentTarget[2]) {
            const deviceVersionInput = event.currentTarget[2] as HTMLInputElement;
            deviceVersion = deviceVersionInput.value;
        }

        const data: FirmwaresFirmwareLoadRequestData = {
            formFile,
            fileName,
            version,
            deviceVersion
        };

        APIRequestPost(`/firmwares/firmwareLoad`, {
            data: data,
            logSuccess: true
        }).then(() => {
            this.setState({
                firmwareText: `Firmware ${version} loaded`
            });
        }).catch(() => {
            this.setState({
                firmwareText: `Firmware ${version} is not loaded!!!`
            });
        });
    }

    updateFirmwares(): void {
        APIRequestGet(`/firmwares/getall`, {
            schema: FirmwareListSchema,
            logSuccess: true
        }).then((response) => {
            this.setState({ loading: false, firmwareList: response.data })
        });
    }

    setRelease(isRelease: boolean, id: number): void {
        this.setState({ loading: true });

        const data: FirmwaresSetReleaseRequestData = {
            isRelease: isRelease,
            id: id.toString()
        };

        APIRequestPost(`/firmwares/setRelease`, {
            data: data
        }).then(() => {
            this.updateFirmwares();
        });
    }

    delete(id: number): void {
        this.setState({ loading: true });

        const data: FirmwaresDeleteRequestData = {
            id: id.toString()
        };

        APIRequestPost(`/firmwares/delete`, {
            data: data
        }).then(() => {
            this.updateFirmwares();
        });
    }

    override render(): ReactNode {
        return (
            <div className='max-width text-page-padding'>
                <h1>Firmware</h1>
                <Form onSubmit={this.onSubmitFile}>
                    <Form.Group controlId="formFile" className="mb-3">
                        <Form.Label>Firmware version</Form.Label>
                        <Form.Control type="file" />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Control type="text" placeholder="Version" />
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Control type="text" placeholder="Device version" />
                    </Form.Group>

                    <Button variant="primary" type="submit">
                        Load
                    </Button>
                </Form>
                <h2>{this.state.firmwareText}</h2>
                {this.state.loading ? (
                    <p><em>Loading...</em></p>
                ) : (
                    <FirmwareInfoTable
                        firmwareList={this.state.firmwareList}
                        setRelease={this.setRelease}
                        deleteEntry={this.delete}
                    />
                )}
            </div>
        );
    }
}
